import React from 'react';
import TFFTypography from '../../styled-components/TFFTypography';
import { TUI_LIGHT } from '../../values/style-values';

const FlexHeaderCell: React.FC = ({}) => {
  return (
    <>
      <div
        id="flex-columns"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          gap: '18px',
          borderBottom: '1px solid #000000',
          margin: '30px 0px 0px 0px',
          paddingBottom: '8px',
        }}
      >
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text="Passengers"
          extraStyle={{ marginLeft: 18, gridColumn: '1', textAlign: 'left' }}
        />

        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text="Product price"
          extraStyle={{ gridColumn: '3', textAlign: 'end' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text="Referred price"
          extraStyle={{ textAlign: 'end' }}
        />
        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text="Refund percentage"
          extraStyle={{ whiteSpace: 'nowrap', textAlign: 'end' }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            whiteSpace: 'nowrap',
            justifyContent: 'flex-end',
          }}
        >
          <TFFTypography color="color-functional-neutral-900" fontWeight="bold" text="Refund amount" />
          <span className="alert-icon alert-icon-variant" style={{ color: '#376AF6', marginTop: '3.5px' }}>
            <span className={`icon small letter-i-circled`} data-theme={TUI_LIGHT}></span>
          </span>
        </div>

        <TFFTypography
          color="color-functional-neutral-900"
          fontWeight="bold"
          text="Redemption"
          extraStyle={{ textAlign: 'center' }}
        />
      </div>
    </>
  );
};

export default FlexHeaderCell;
